import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStoreService } from '../../data-access/store/auth-store.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authStoreService = inject(AuthStoreService);

  const token = localStorage.getItem('access_token');

  if (token || authStoreService.accessToken()) {
    return true; // allow route activation
  }

  // No token → redirect to login
  router.navigate(['/login']);

  return false;
};
